<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 2v20M2 12h20"/>
    <path d="M4 4l16 16M4 20l16-16"/>
  </svg>
</template>

<script>
export default {
  name: 'ShadowIcon'
}
</script> 